export default "__VITE_ASSET__f12a664b__"